export {};

const onmount = require('onmount');

const TRIGGER_SELECTOR = '.js-anonymousNavbar-toggle';
const CLOSE_SELECTOR = '.js-anonymousNavbar-close';
const BACKDROP_SELECTOR = '.js-anonymousNavbar-backdrop';
const SUBMENU_TOGGLE_SELECTOR = '.js-anonymousNavbar-submenuToggle';
const MENU_SELECTOR = '.js-anonymousNavbar-menu';
const SUBMENU_SELECTOR = '.lj-anonymousNavbar__subMenu';
const ITEM_HAS_SUB_CLASS = 'lj-anonymousNavbar__item--hasSub';
const SUBITEM_HAS_SUB_CLASS = 'lj-anonymousNavbar__subItem--hasSub';
const OPEN_CLASS = 'lj-anonymousNavbar__menu--open';
const ITEM_OPEN_CLASS = 'lj-anonymousNavbar__item--submenuOpen';
const SUBITEM_OPEN_CLASS = 'lj-anonymousNavbar__subItem--submenuOpen';
// Length-valued ceiling — `max-height: none` can't be animated to/from.
const RELEASED_MAX_HEIGHT = '9999px';
// Mirror of `$lj-anonymousNavbar-submenu-transition` in `_anonymous_navbar.scss`.
const TRANSITION_MS = 300;

function setMenuOpen(menu: HTMLElement, trigger: HTMLElement, open: boolean) {
  menu.classList.toggle(OPEN_CLASS, open);
  trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
}

onmount(TRIGGER_SELECTOR, function () {
  const trigger = this as HTMLElement;
  const menu = document.querySelector<HTMLElement>(MENU_SELECTOR);
  if (!menu) return;

  trigger.addEventListener('click', () => {
    setMenuOpen(menu, trigger, !menu.classList.contains(OPEN_CLASS));
  });
});

onmount(CLOSE_SELECTOR, function () {
  const close = this as HTMLElement;
  const trigger = document.querySelector<HTMLElement>(TRIGGER_SELECTOR);
  const menu = document.querySelector<HTMLElement>(MENU_SELECTOR);
  if (!trigger || !menu) return;

  close.addEventListener('click', () => {
    setMenuOpen(menu, trigger, false);
  });
});

onmount(BACKDROP_SELECTOR, function () {
  const backdrop = this as HTMLElement;
  const trigger = document.querySelector<HTMLElement>(TRIGGER_SELECTOR);
  const menu = document.querySelector<HTMLElement>(MENU_SELECTOR);
  if (!trigger || !menu) return;

  backdrop.addEventListener('click', () => {
    setMenuOpen(menu, trigger, false);
  });
});

function openSubmenu(parentItem: HTMLElement, submenu: HTMLElement, openClass: string) {
  submenu.style.maxHeight = `${submenu.scrollHeight}px`;
  parentItem.classList.add(openClass);

  // Release the cap after the slide so nested expansions aren't clipped
  // by the outer's max-height.
  window.setTimeout(() => {
    if (parentItem.classList.contains(openClass)) {
      submenu.style.maxHeight = RELEASED_MAX_HEIGHT;
    }
  }, TRANSITION_MS);
}

function closeSubmenu(parentItem: HTMLElement, submenu: HTMLElement, openClass: string) {
  // Snap to current rendered height with transitions off (the released
  // 9999px cap can't be animated from), then re-enable and animate to 0.
  const prevTransition = submenu.style.transition;
  submenu.style.transition = 'none';
  submenu.style.maxHeight = `${submenu.scrollHeight}px`;
  void submenu.offsetHeight; // force reflow
  submenu.style.transition = prevTransition;

  parentItem.classList.remove(openClass);
  submenu.style.maxHeight = '';
}

onmount(SUBMENU_TOGGLE_SELECTOR, function () {
  const toggle = this as HTMLElement;
  const parentItem = toggle.closest<HTMLElement>(
    `.${ITEM_HAS_SUB_CLASS}, .${SUBITEM_HAS_SUB_CLASS}`
  );
  if (!parentItem) return;

  // `:scope >` restricts to the direct-child submenu. An `__item--hasSub`
  // contains its own `__subMenu`, which in turn nests `__subMenu--nested`
  // descendants. The toggle should drive only the level it sits on.
  const submenu = parentItem.querySelector<HTMLElement>(`:scope > ${SUBMENU_SELECTOR}`);
  if (!submenu) return;

  const openClass = parentItem.classList.contains(SUBITEM_HAS_SUB_CLASS)
    ? SUBITEM_OPEN_CLASS
    : ITEM_OPEN_CLASS;

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const willOpen = !parentItem.classList.contains(openClass);
    if (willOpen) {
      openSubmenu(parentItem, submenu, openClass);
    } else {
      closeSubmenu(parentItem, submenu, openClass);
    }
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });
});
